var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 46.25L50 12.5L86.875 46.25V87.5H62.5V68.75H37.5V87.5H12.5V46.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0733 9.24809C48.7475 7.74127 51.2922 7.75191 52.9538 9.27268L89.8288 43.0227C90.7343 43.8514 91.25 45.0225 91.25 46.25V87.5C91.25 89.9162 89.2912 91.875 86.875 91.875H62.5C60.0838 91.875 58.125 89.9162 58.125 87.5V73.125H41.875V87.5C41.875 89.9162 39.9162 91.875 37.5 91.875H12.5C10.0838 91.875 8.125 89.9162 8.125 87.5V46.25C8.125 45.0097 8.65141 43.8278 9.57328 42.9981L47.0733 9.24809ZM16.875 48.1985V83.125H33.125V68.75C33.125 66.3338 35.0838 64.375 37.5 64.375H62.5C64.9162 64.375 66.875 66.3338 66.875 68.75V83.125H82.5V48.1766L49.9753 18.4082L16.875 48.1985Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.fc7015f46d9972eaef1c579661a3bf70.svg";
export { ForwardRef as ReactComponent };